<template>
  <div>
    <div v-if="!isService">
      <b-jumbotron :lead="$t('DHCPv6 service not available')">
        <b-button class="mt-3" variant="secondary" @click="reload">{{ $t('Try again')}}</b-button>
      </b-jumbotron>
    </div>
    <div v-if="isService">
      <b-tabs pills card>
        <b-tab :title="$t('Global')" active @click="() => { $router.push('/DHCPv6/mainDHCPv6') }"/>
        <b-tab :title="$t('Subnets')" @click="() => { $router.push('/DHCPv6/subnets') }"/>
        <b-tab :title="$t('Shared networks')" @click="() => { $router.push('/DHCPv6/sharedNetworks') }"/>
        <b-tab :title="$t('Client classification')"  @click="() => { $router.push('/DHCPv6/clientClassification') }"/>
        <b-tab :title="$t('Option-def')"  @click="() => { $router.push('/DHCPv6/optionDef') }"/>
      </b-tabs>
      <router-view style="margin-top:-30px"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isService: false
    }
  },
  methods: {
    reload () {
      this.$store.dispatch('Settings/GET_DHCPV6')
      this.load()
    },
    load () {
      let dhcp6 = this.$store.getters['Settings/DHCPV6']
      if (dhcp6.result === 0) {
        this.isService = true
      } else {
        this.isService = false
      }
    }
  },
  mounted () {
    this.load()
    this.$store.dispatch('Settings/GET_DHCPV6')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/DHCPv6/main.vue